export const lightTheme = {
  body: "#FFF",
  mainBG: "#FFF",
  text: "#d8a31a",
  text2: "#877455",
  footer: "#FFEECB",
  bgColor: "#e6f4f1",
  borderColor: "#f2f2f2",
  heroButton: "#d8a31a",
  footerText: "#877455",
  navText: "#d8a31a",
};

export const darkTheme = {
  footer: "#414756",
  mainBG: "black",
  text2: "#A5ABBD",
  text: "#F5F9FF",
  body: "#57586D",
  bgColor: "#57586D",
  borderColor: "black",
  heroText: "#A5ABBD",
  heroButton: "#414756",
  footerText: "#A5ABBD",
  navText: "#F5F9FF",
};
